import React from "react";
import ExcludedMessage from "./ExcludedMessage.js";

export default function ResultDisplayExcluded(props) {
    return (
        <ExcludedMessage address={props.address}/>
    )
}